export class SameEmailError extends Error {
  code?: string = 'account/same-email';
}
